<template>
  <section>
    <div>
      <div
        v-for="(course,index) in courseList"
        :key="index"
      >
        <div class="border rounded-5 p-2 my-1">
          <div
            v-for="(courseKey, i) in Object.keys(course)"
            :key="i"
          >
            <div
              v-if="course[courseKey]"
              class="d-flex border-bottom pb-1 mb-1"
            >
              <div class="font-weight-bold flex-1">{{ courseKey | decamelize }}</div>
              <div v-if="courseKey === 'withConditions'">
                <AppBadge
                  v-for="(cond,cindx) in course[courseKey]"
                  :key="cindx"
                  class="mx-1"
                >
                  {{ Object.values(cond).join(' ') }}
                </AppBadge>
              </div>
              <div v-else>{{ course[courseKey] }}</div>
            </div>
          </div>
          <AppButton
            variant="danger"
            class="p-1"
            @click="deleteItem(index)"
          >
            <AppIcon name="delete" />
            delete
          </AppButton>
        </div>
      </div>
    </div>
    <AppButton
      :raised="false"
      class="mt-2"
      @click="modals.addCourse=true"
    >
      <AppIcon name="add" /> Course
    </AppButton>
    <AppModal
      v-if="modals.addCourse"
      :stacked="true"
      class="add__requisite__course__modal"
      @close="closeModal"
      @clickaway="closeModal"
    >
      <template #modal-header>
        <AppHeading>Add course</AppHeading>
      </template>
      <template #modal-body>
        <AppSwitch
          :value="addDynamic"
          label="Add dynamic course criteria?"
          @input="addDynamic = $event"
        />
        <AdvanceRequisiteCourseSelectDynamic
          v-if="addDynamic"
          v-model="newVal"
          label="Select dynamic course criteria"
          placeholder="Set dynamic course criteria"
        />
        <FormCourseSelect
          v-else
          :value="newVal && newVal.courseId"
          label="Select Course"
          placeholder="Set course"
          :config="{ multiple: false, includePending: true }"
          @input="setCourse"
        />
      </template>
      <template #modal-footer>
        <div class="d-flex mr-3">
          <AppButton @click="closeModal">Cancel</AppButton>
          <AppButton
            class="ml-2"
            :raised="true"
            @click="addNewItem"
          >
            Save
          </AppButton>
        </div>
      </template>
    </AppModal>
  </section>
</template>

<script>
import FormCourseSelect from '@/components/Forms/FormCourseSelect'
import AdvanceRequisiteCourseSelectDynamic from './AdvanceRequisiteCourseSelectDynamic'
import { mapGetters } from 'vuex'
import _pick from 'lodash/pick'
import useCourse from '@cm/client/composables/useCourse'

export default {
  components: {
    FormCourseSelect,
    AdvanceRequisiteCourseSelectDynamic,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      modals: {
        addCourse: false,
      },
      addDynamic: false,
      newVal: undefined,
    }
  },
  setup () {
    const {
      generateCourseLabel,
    } = useCourse()
    return {
      generateCourseLabel,
    }
  },
  computed: {
    ...mapGetters('curriculumCourses', [ 'cmCourseByEffectiveDatesRangeLookup' ]),
    ...mapGetters('departments', [ 'departmentDisplayName' ]),
    courseList () {
      return this.value.map(this.formatCourseData)
    },
  },
  watch: {
    addDynamic () {
      this.newVal = undefined
    },
  },
  methods: {
    setCourse (courseId) {
      this.newVal = { courseId }
    },
    courseDisplayName (courseData) {
      return this.generateCourseLabel(courseData)
    },
    formatCourseData (course) {
      // Only return the type field is the type is not the default "Simple or course type"
      const courseData = course.courseId && this.cmCourseByEffectiveDatesRangeLookup(course.courseId)
      return {
        ...(course.type && course.type !== 'simple' && { type: this.decamelize(course.type) }),
        ...(course.departmentId && { department: this.departmentDisplayName(course.departmentId) || course.departmentId }),
        ...(course.courseId && courseData && { course: this.courseDisplayName(courseData) }),
        ...(!courseData && course.subjectCode && { subjectNumber: course.subjectCode }),
        ...(!courseData && course.courseNumber && { courseNumber: course.courseNumber }),
        ..._pick(course, [ 'department', 'min', 'max', 'withConditions' ]),
      }
    },
    closeModal () {
      this.modals.addCourse = false
    },
    addNewItem () {
      if (!this.newVal) return
      this.$emit('input', [ ...this.value, this.newVal ])
      this.newVal = undefined
      this.addDynamic = false
      this.closeModal()
    },
    deleteItem (index) {
      this.$emit('input', this.value.filter((v, i) => index !== i))
    },
  },
}
</script>

<style scoped>
.add__requisite__course__modal >>> .modal-content {
  overflow: visible;
  min-height: 60vh;
}
</style>
